<div style="height: 20px"></div>

<div *ngIf="!header" style="padding-top: 32px"></div>

<header #bigHeader class="big container" *ngIf="header">
  <div class="date">
    <h2>{{ match.competition }}</h2>
    <h3>
      <span>{{ getStageLabel(match.stage) }} {{ match.day }} {{'·'}} </span>
      <span class="date" *ngIf="!live || !hasStarted()">{{ match.date | date:'EEEE, dd/MM/yyyy HH:mm' }}</span>
      <span class="live" *ngIf="live && hasStarted()">{{ 'Live' | translate }}</span>
    </h3>
  </div>
  <div class="scoreboard">
    <div class="team home" *ngIf="match.home">
      <img src="{{ match?.home?.img || context.defaultTeamImg }}" onerror="this.src = '/assets/img/teams/default_badge.svg'"/>
      <h4 class="code">{{ match.home ? match.home.code : '---' }} <span *ngIf="match.home">{{ match.home.name }}</span></h4>
      <p class="difference" [class.less]="score.diff < 0" [class.more]="score.diff > 0">{{ live ? fullScore.diff : score.diff }}</p>
    </div>
    <div class="result">
      <div class="score {{ (live && hasStarted()) ? 'quarter'+quarter : '' }}" [class.live]="live">
        <span class="full-score home">{{ fullScore.home }}</span>
        <span class="quarter-score home">{{ live ? fullScore.home : score.home }}</span>
        <span class="quarter-score visitor">{{ live ? fullScore.visitor : score.visitor }}</span>
        <span class="full-score visitor">{{ fullScore.visitor }}</span>
      </div>
      <div class="time" [class.live]="live" [class.notstarted]="live && !hasStarted()">
        <ng-container *ngIf="!live">{{ score.quarter }}</ng-container>
        <ng-container *ngIf="live && hasStarted()">
          <span class="quarter">{{ score.quarter }}</span>
          <span class="time" [innerHTML]="score.time | matchTime"></span>
          <span></span>
        </ng-container>
        <ng-container *ngIf="live && !hasStarted()">
          <span>{{ 'Live on' | translate }} {{ match.date | date:'EEEE' }} {{ 'at' | translate }} {{ match.date | date:'HH:mm' }}</span>
        </ng-container>
      </div>
    </div>
    <div class="team visitor" *ngIf="match.visitor">
      <img src="{{ match?.visitor?.img || context.defaultTeamImg }}" onerror="this.src = '/assets/img/teams/default_badge.svg'"/>
      <h4 class="code">{{ match.visitor ? match.visitor.code : '---' }} <span *ngIf="match.visitor">{{ match.visitor.name }}</span></h4>
    </div>
  </div>
  <div class="place">
    {{ match.place }}
  </div>
</header>
<header class="small" #smallHeader [class.hidden]="!headerScrollActive" *ngIf="header">
  <div class="scoreboard">
    <div class="container">
      <div class="team home" *ngIf="match.home">
        <img src="{{ match?.home?.img || context.defaultTeamImg }}" onerror="this.src = '/assets/img/teams/default_badge.svg'"/>
        <h4 class="name">{{ match.home.name }}</h4>
        <p class="difference" [class.less]="score.diff < 0" [class.more]="score.diff > 0">{{ live ? fullScore.diff : score.diff }}</p>
      </div>
      <div class="score {{ (live && hasStarted()) ? '' : 'quarter'+quarter }}" [class.live]="live">
        <span class="full-score home">{{ fullScore.home }}</span>
        <span class="quarter-score home">{{ live ? fullScore.home : score.home }}</span>
        <span class="quarter-score visitor">{{ live ? fullScore.visitor : score.visitor }}</span>
        <span class="full-score visitor">{{ fullScore.visitor }}</span>
      </div>
      <div class="team visitor" *ngIf="match.visitor">
        <img src="{{ match?.visitor?.img || context.defaultTeamImg }}" onerror="this.src = '/assets/img/teams/default_badge.svg'"/>
        <h4 class="name">{{ match.visitor.name }}</h4>
      </div>
    </div>
  </div>
  <div class="info">
    <div class="container">
      <p class="left">
        <span>{{ match.competition }}</span><span class="separator"> {{'·'}} </span>{{ getStageLabel(match.stage) }} {{ match.day }}
      </p>
      <div class="time" [class.live]="live">
        <ng-container *ngIf="!live">{{ score.quarter }}</ng-container>
        <ng-container *ngIf="live && hasStarted()">
          <span class="quarter">{{ score.quarter }}</span>
          <span class="time" [innerHTML]="score.time | matchTime"></span>
          <span></span>
        </ng-container>
        <ng-container *ngIf="live && !hasStarted()">
          <span>{{ 'Live' | translate }} {{ 'at' | translate }} {{ match.date | date:'HH:mm' }}</span>
        </ng-container>
      </div>
      <p class="right">
        <span class="date" *ngIf="!live || !hasStarted()">
          <span>{{ match.date | date:'EEEE, dd/MM/yyyy HH:mm' }}</span>
          <small>{{ match.date | date:'dd-MM-yyyy' }}</small>
        </span>
        <span class="live" *ngIf="live && hasStarted()">{{ 'Live' | translate }}</span>
        <span class="place">{{'·'}} {{match.place}}</span>
      </p>
    </div>
  </div>
</header>

